import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';
import { RoleType } from '@promo/shared';

/**
 * Custom hook to fetch global roles for a user by userId
 */
export function useGlobalRoles(userId?: string | null) {
  return useQuery<RoleType[], Error>({
    queryKey: ['globalRoles', userId],
    queryFn: () => userId ? get<RoleType[]>('/roles', { userId }) : Promise.resolve([]),
    enabled: Boolean(userId),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
} 